import { useState } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Stack,
  TextField,
} from '@mui/material';
import { useCounselorOptions } from '../../hooks/useCounselorOptions';

interface AssignLeadDialogProps {
  open: boolean;
  isReassignment: boolean;
  errorMessage: string | null;
  onClose: () => void;
  onSubmit: (userId: number, reason?: string) => Promise<void>;
}

export const AssignLeadDialog = ({
  open,
  isReassignment,
  errorMessage,
  onClose,
  onSubmit,
}: AssignLeadDialogProps) => {
  const [userId, setUserId] = useState<number | ''>('');
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const { counselors } = useCounselorOptions(open);

  const handleSubmit = async () => {
    if (!userId) return;
    setSubmitting(true);
    try {
      await onSubmit(userId, reason || undefined);
      setReason('');
      setUserId('');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{isReassignment ? 'Transfer lead' : 'Assign lead'}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
          <TextField select label="Assign to counselor" fullWidth value={userId} onChange={(e) => setUserId(Number(e.target.value))}>
            {counselors.map((u) => (
              <MenuItem key={u.id} value={u.id}>
                {u.firstName} {u.lastName}
              </MenuItem>
            ))}
          </TextField>
          {isReassignment && (
            <TextField
              label="Reason (optional)"
              fullWidth
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" disabled={!userId || submitting} onClick={handleSubmit}>
          {submitting ? 'Saving…' : isReassignment ? 'Transfer' : 'Assign'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
